import _ from 'underscore';
import Socket from '../connection/socket';
import { Message } from '../stores/types/connection';
import { getState, socketListenerDispatch } from './socket-listener-main';
import {setHiddenTitles} from '../stores/actions/video';
import {setVideoTitlesHaveFired} from '../stores/actions/shots';
import { GreenroomState } from '../stores/types/types';
import printOTDebugLogForStreamId from '../utils/opentok-debug-helper';
import { Subscriber } from '../utils/video/opentok-connection';
import { OPENTOK_STREAM_AUDIO_ADD_UNMUTED_ID } from '../stores/actions/opentok';
import { showAlert } from '../components/general-components/alert-service';

function handleRequestIsLiveState(socket: Socket, message: any) {
	const {
		VideoReducer: {
			isLive,
		},
	} = getState();

	socket.sendMessage('isLive-state-update', { isLive, email: message.message });
	socket.sendMessage('isLive-state-update', { isLive, email: message.message }, `temp-${message.message.toLowerCase()}`);
}

function handleRequestState(socket: Socket, message: any) {
	const {
		VideoReducer: {
			isLive,
		},
		SessionReducer: {
			session,
		},
	} = getState();

	if (session !== message.message) {
		socket.sendMessage('is-live', isLive);
	}
}

function handleHoldSlideConvertError(message: Message) {
	const {
		SessionReducer: {
			user,
		},
	} = getState() as GreenroomState;

	// show error toaster if you uploaded this hold slide
	if (user && (user.gr_user === message.message)) {
		showAlert({
			message: 'File Upload Error',
			description: 'The file selected could not be uploaded',
			duration: 4000,
			type: 'error',
		});
	}
}

export default function Video(socket: Socket) {
	const {
		SessionReducer: {
			host,
		},
	} = getState();

	if (host) {
		socket.addListener('request-state', handleRequestState.bind(null, socket));
		socket.addListener('request-isLive-state', handleRequestIsLiveState.bind(null, socket));
	}

	socket.addListener('hold-slide-convert-error', handleHoldSlideConvertError);
}
